module.exports = __webpack_public_path__ + "static/media/15604447042181161364926.02397b32.jpg";